<template>
  <v-main>
    <SignupHeader />
    <v-card
      class="mt-5 mx-auto"
      elevation="0"
    >
      <v-card-title class="mb-4 mt-4 display-1 text-grey-darken-2 text-h4">
        {{ $t('ResetPassword.Title') }}
      </v-card-title>

      <!-- 期限切れの場合 -->
      <template v-if="isKeyOk===false">
        <v-card-text
          class="mt-5"
          style="max-width: 700px"
        >
          <v-alert
            variant="outlined"
            type="error"
            :value="true"
          >
            {{ $t('ResetPassword.ExpiredMessage') }}
          </v-alert>
        </v-card-text>
        <v-row
          class="mt-3"
          style="max-width: 700px"
        >
          <v-spacer />
          <v-btn
            flat
            color="secondary"
            @click="$router.push({name: 'Login'})"
          >
            {{ $t('Back') }}
          </v-btn>
        </v-row>
      </template>

      <!-- 期限内の場合 -->
      <template v-if="isKeyOk===true && submitted===false">
        <v-card-text
          class="mt-5 align-center justify-end"
          style="max-width: 600px"
        >
          <PasswordInput
            v-model="formData.password"
            field-key="password"
            :label="$t('ResetPassword.NewPassword')"
            required
          />
          <v-spacer />
        </v-card-text>

        <v-card-actions style="max-width: 600px">
          <v-spacer />
          <ActionButton
            submit
            @click="submit()"
          />
        </v-card-actions>
      </template>

      <!-- 送信後メッセージ -->
      <template v-if="submitted===true">
        <v-card-text
          class="mt-5 align-center justify-end"
          style="max-width: 700px"
        >
          <v-alert
            variant="outlined"
            type="info"
            :value="true"
          >
            {{ $t('ResetPassword.SubmittedMessage') }}
          </v-alert>
        </v-card-text>

        <v-card-actions
          class="my-3"
          style="max-width: 700px"
        >
          <v-spacer />
          <v-btn
            color="secondary"
            @click="$router.push({name: 'Login'})"
          >
            {{ $t('Back') }}
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-main>
</template>

<script>
import { mapGetters } from 'vuex'
import http from '@/library/no_session_http'
import ActionButton from '@/components/parts/button/ActionButton'
import SignupHeader from '@/components/content/SignupHeader'
import PasswordInput from '@/components/parts/inputs/PasswordInput'

export default {
  components: {
    PasswordInput,
    SignupHeader,
    ActionButton
  },
  props: {},
  data: () => ({
    formData: {
      password: '',
      key: null
    },
    isKeyOk: null,
    submitted: false
  }),
  computed: {
    ...mapGetters(['errorRes'])
  },
  created () {
    this.$store.dispatch('clearErrorRes')
    if (!this.$route.query.key) {
      this.$router.push({ name: 'Login' })
    } else {
      this.checkKey()
    }
  },
  methods: {
    checkKey () {
      http.get('reset-password/', { params: { key: this.$route.query.key } }).then(
        (res) => {
          this.isKeyOk = true
        },
        (error) => {
          console.error(error)
          this.isKeyOk = false
        }
      )
    },
    submit () {
      this.formData.key = this.$route.query.key
      http.put('reset-password/', this.formData).then(
        (res) => {
          this.submitted = true
        }
      )
    },
    redirectLoginPage () {
      location.href = '/login'
    }
  }
}
</script>

<style scoped>
</style>
